import JobDetailSidebar from './JobDetailSidebar'

export default JobDetailSidebar
